@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.tagsPanelWrapper {
  padding: 0 16px;
}

.tagsPanel {
  // flex: 0 0 5%;
  width: 100%;
  min-width: 0;
  margin: 0;
  display: flex;
  position: relative;
  align-items: center;
  // margin-bottom: 8px;
  background-color: v.$palette-white;
  // box-shadow: v.$shadow-2;
  border-radius: 10px;
  @include m.appearance(0.2);
  z-index: v.$z-index-tags-panel;
  padding: 8px 0;
}

.tagFilterLoaderContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: v.$z-index-tag-filter-loader-container;
  display: flex;
  justify-content: center;
  align-items: center;
  background: color-mix(in srgb, v.$palette-white 70%, transparent);
}
